<div appBlockCopyPaste class="candidate-coding-question-view">
  <div mat-dialog-title class="coding-d-heading">
    <div class="heading">CODING CHALLENGE</div>
  </div>

  <div class="main-container" mat-dialog-content>
    <div class="question-section">
      <div class="header-sec">
        <span class="problem-txt">Problem</span>
      </div>
      <div class="q-sec">
        <div class="title">Problem Statement</div>
        <div class="q-details">
          <ng-container *ngIf="data?.details?.question?.questionText">
            <div class="question-title preline" [innerHTML]="formattedQuestionText"></div>

            <div class="title">Instructions</div>
            <div *ngIf="condingInstructions" class="preline" [innerHTML]="formatQuestionText(condingInstructions)">
            </div>
          </ng-container>
        </div>
      </div>
    </div>

    <div class="gap"></div>

    <div class="editor-section">
      <div class="header-sec">
        <mat-icon class="mat-icon notranslate material-icons save-icon" data-mat-icon-type="font"
          (click)="sendPartialSave()">
          save
        </mat-icon>
        <div class="timer-sec">
          <mat-icon class="timer-icon">access_time</mat-icon>
          <!-- Question-level timer (per coding question) -->
          <div class="timer-label" *ngIf="data?.details?.remainingTime">Question:</div>
          <countdown #cd [config]="{leftTime: data?.details?.remainingTime, 
              format: 'HH:mm:ss', notify: [120]}" (event)="handleEvent($event)"></countdown>

        </div>
        <div class="lang-sec">
          <mat-form-field appearance="outline" class="fname-form-field">
            <mat-select panelClass="lang-select" placeholder="Coding Language" [value]="selectedLang"
              (selectionChange)="onLanguageSelection($event)">
              <mat-option *ngFor="let lang of codingLanguages" [value]="lang">
                {{lang?.code_language}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <button mat-stroked-button color="primary" class="end-btn" (click)="closeCodingQuestion()">End</button>
        </div>
      </div>
      <div class="editor-and-result-container">
        <div class="app-ace-editor" #verifyCodeEditor></div>
        <!-- <div class="test-output-results-sec" *ngIf="runCompleted">
          <div class="title-txt">RESULT</div>
          <div class="success-test-cases">Test cases passed: <span>{{runTestResult?.success || 0}}</span></div>
          <div class="failure-test-cases">Test cases Failed: <span>{{runTestResult?.failure || 0}}</span></div>
          <div class="total-test-cases">Total: <span>{{runTestResult?.success + runTestResult?.failure +
            runTestResult?.errored}}</span></div>
        </div> -->
        <div class="error-test-cases-result">
          <p class="preline">{{runTestResult || 'Check output here.'}} </p>
        </div>
      </div>
      <div class="run-submit-sec">
        <div class="saving-code-txt">
          <ng-container *ngIf="isAutoSaveInprogress">
            <mat-icon>check</mat-icon>
            <span>Saving Code...</span>
          </ng-container>
        </div>
        <div>
          <button mat-stroked-button (click)="runTestCases()" class="run-btn">
            <span class="run-code-btn-inner">
              <mat-icon class="mat-icon notranslate material-icons mat-icon-no-color" data-mat-icon-type="font"
                *ngIf="btnRunCodeTxt ==='Run'">
                play_arrow
              </mat-icon>
              <span> {{btnRunCodeTxt}} </span>
              <mat-spinner class="run-spinner" *ngIf="btnRunCodeTxt !=='Run'"></mat-spinner>
            </span>
          </button>
          <button mat-raised-button class="submit-c-question" (click)="submitQuestion()">Submit</button>
        </div>
      </div>
    </div>
  </div>
</div>